import { Link } from "react-router-dom";
import { BookOpen, ShoppingBag } from "lucide-react";
import { MaskLines, Reveal } from "../components/Motion";
import { useFetch } from "../lib/useFetch";
import { asList } from "../lib/api";

export default function Issues() {
  const { data } = useFetch("/issues", []);
  const issues = asList(data);
  return (
    <div className="px-5 lg:px-12 pt-14" data-testid="issues-page">
      <p className="eyebrow mb-6">The magazine</p>
      <h1 className="f-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[0.95]"><MaskLines lines={["Every issue,", <em key="o" className="font-light">on the shelf.</em>]} /></h1>
      <div className="mt-20 space-y-24">
        {issues.map((is, i) => (
          <Reveal key={is.id}>
            <div className={`grid md:grid-cols-12 gap-8 lg:gap-16 items-center border-t rule pt-12`} data-testid={`issue-row-${is.id}`}>
              <Link to={`/reader/${is.id}`} className={`md:col-span-4 group ${i % 2 ? "md:order-2 md:col-start-9" : ""}`}>
                <div className="aspect-[2/3] overflow-hidden shadow-[0_40px_60px_-30px_rgba(0,0,0,0.45)] max-w-[300px] mx-auto md:max-w-none">
                  <img src={is.cover} alt={is.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" loading="lazy" />
                </div>
              </Link>
              <div className={`md:col-span-7 ${i % 2 ? "md:order-1 md:col-start-1" : "md:col-start-6"}`}>
                <p className="f-mono text-sm text-[var(--muted)]">Vol. {is.volume} · No. {is.number} · {is.season}</p>
                <h2 className="f-serif text-4xl sm:text-5xl mt-3 tracking-tight">{is.title}</h2>
                <p className="text-lg text-[var(--ink-2)] mt-5 leading-relaxed max-w-xl">{is.summary}</p>
                <div className="mt-8 flex flex-wrap gap-3">
                  <Link to={`/reader/${is.id}`} className="btn-ink h-11 px-5 inline-flex items-center gap-2 font-semibold" data-testid={`issue-read-${is.id}`}><BookOpen size={17} /> Read online</Link>
                  <Link to="/shop" className="btn-line h-11 px-5 inline-flex items-center gap-2 font-semibold" data-testid={`issue-buy-${is.id}`}><ShoppingBag size={17} /> Buy print</Link>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
